import { TrendUpIcon, TrendDownIcon } from "@phosphor-icons/react";

/**
 * KpiCard estilo "dashboard SaaS premium" (inspirado en imagen del cliente).
 * - Label pequeño arriba en mayúsculas
 * - Valor MUY grande (text-4xl/5xl) en Montserrat
 * - Comparativa con flecha colorada según tendencia
 * - Icono opcional discreto en esquina
 */
export default function KpiCard({ label, value, icon: Icon, accent = "green", trend, sub, testId }) {
  const accentMap = {
    green: "text-agro-green",
    yellow: "text-agro-yellow",
    blue: "text-blue-400",
    red: "text-red-400",
  };
  const accentBgMap = {
    green: "bg-agro-green/10",
    yellow: "bg-agro-yellow/10",
    blue: "bg-blue-500/10",
    red: "bg-red-500/10",
  };
  const a = accentMap[accent] || accentMap.green;
  const ab = accentBgMap[accent] || accentBgMap.green;
  return (
    <div
      data-testid={testId}
      className="group relative bg-card border border-border/60 rounded-2xl p-5 transition-all duration-200 hover:border-agro-green/40 overflow-hidden"
    >
      <div className="flex items-center justify-between mb-1">
        <div className="text-[10px] uppercase tracking-[0.18em] text-text-muted font-medium">{label}</div>
        {Icon && (
          <div className={`w-8 h-8 rounded-full ${ab} flex items-center justify-center ${a}`}>
            <Icon size={14} weight="bold" />
          </div>
        )}
      </div>
      <div
        className="font-heading font-semibold text-text-primary leading-none tracking-tight text-3xl md:text-4xl lg:text-[2.5rem]"
        data-testid={`${testId}-value`}
      >
        {value}
      </div>
      <div className="mt-2 flex items-center gap-2">
        {trend !== undefined && trend !== null && (
          <span className={`inline-flex items-center gap-1 text-xs font-medium ${trend >= 0 ? "text-agro-green" : "text-red-400"}`}>
            {trend >= 0 ? <TrendUpIcon size={12} weight="bold" /> : <TrendDownIcon size={12} weight="bold" />}
            {Math.abs(trend).toFixed(1)}%
          </span>
        )}
        {sub && <span className="text-[11px] text-text-secondary truncate">{sub}</span>}
      </div>
    </div>
  );
}
